@if (show) {
  <div class="opf-fees-container">
    <h2>{{ 'modal.opfConfirmHeader' | translate }}</h2>
    <p [innerHTML]="'modal.opfConfirmDesc1' | translate"></p>
    <p [innerHTML]="'modal.opfConfirmDesc2' | translate"></p>
    <p [innerHTML]="'modal.opfConfirmDesc3' | translate"></p>
    <div class="confirm-opf-buttons">
      <libero-button
        label="{{ 'global.buttons.back' | translate }}"
        btnClasses="btn--icon-text icon--secondary"
        (click)="onBackBtnClick()"
      ></libero-button>
      <libero-button
        label="{{ 'modal.opfConfirmBtn' | translate }}"
        btnClasses="btn--primary btn--heading"
        (click)="onContinueBtnClick()"
        data-cy="modal-create-investment-button"
      ></libero-button>
    </div>
  </div>
}
